var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8335 15.6667L11.5118 13.5649C13.617 12.3619 15.8914 11.4826 18.2584 10.9566V10.9566C21.7108 10.1894 25.2895 10.1894 28.7419 10.9566V10.9566C31.1089 11.4826 33.3833 12.3619 35.4886 13.5649L39.1668 15.6667",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 21.542L15.6667 19.5836L17.9991 18.709C21.5458 17.379 25.4542 17.379 29.0009 18.709L31.3333 19.5836L35.25 21.542",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 27.417L18.4816 26.9887C19.2139 26.6225 19.9841 26.3376 20.7784 26.139V26.139C22.5653 25.6923 24.4347 25.6923 26.2216 26.139V26.139C27.0159 26.3376 27.7861 26.6225 28.5184 26.9887L29.375 27.417",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6962,
    cy: 33.4878,
    r: 1.175,
    fill: "#1C1C1C",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/Wifi.484019abf775f009b41fc1baa6892bb0.svg";
export { ForwardRef as ReactComponent };